import {c} from "../../landing/landingTokens";

// Soft, borderless filled fields — rounded, faint fill, no underline. On focus the fill warms
// to a light purple with a gentle glow ring; on error it tints softly red instead of drawing a
// hard border. Helper text keeps a reserved line so validation never makes the form jump.
export const fieldSx = {
  "& .MuiFilledInput-root": {
    borderRadius: "14px",
    backgroundColor: "rgba(20,21,26,0.04)",
    overflow: "hidden",
    transition: "background-color .2s ease, box-shadow .2s ease",
    "&:before, &:after": {display: "none"},
    "&:hover": {backgroundColor: "rgba(20,21,26,0.06)"},
    "&.Mui-focused": {
      backgroundColor: "rgba(129,140,248,0.08)",
      boxShadow: "0 0 0 2px rgba(129,140,248,0.45)",
    },
    "&.Mui-disabled": {backgroundColor: "rgba(20,21,26,0.025)"},
    "&.Mui-error": {
      backgroundColor: "rgba(239,68,68,0.05)",
      boxShadow: "0 0 0 2px rgba(239,68,68,0.25)",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {color: c.purpleDeep},
  "& .MuiInputLabel-root.Mui-error": {color: "#DC2626"},
  "& .MuiFormHelperText-root": {minHeight: 18, m: "4px 6px 0", fontSize: 12.5, lineHeight: 1.4},
};
